import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import IndexSaga from './Index-Saga';
import vaultReducer from 'store/vaults';
import authReducer from 'store/auth';
import UserReducer from 'store/user';

const rootReducer = combineReducers({
	user: UserReducer,
	vault: vaultReducer,
	auth: authReducer,
});

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(sagaMiddleware),
});

sagaMiddleware.run(IndexSaga);

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export { store };
export type { RootState, AppDispatch };
